export default {"src":"/_next/static/media/html.a5f1e145.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};